import axios from 'axios'

export default {
  methods: {
    submitRequest: function (answersToPost) {
      var append = this.token ? `/${this.token}` : ''
      const postData = {
        answers: answersToPost
      }

      postData.locale = this.locale

      if (this.isGeneric) {
        postData.guest = Object.entries(this.guest).reduce(
          (acc, [key, { value }]) => {
            acc[key] = value
            return acc
          },
          {}
        )
      }
      if (this.pms_external_id) {
        postData.token = this.pms_external_id
      }
      if (this.anonymousGuest && !this.token) {
        append = `?g=${this.anonymousGuest}`
      }
      return axios
        .post(
          `${process.env.SURVEYS_API_URL}/surveys/${this.slug}/fill${append}`,
          postData
        )
        .then(res => {
          this.surveyStatus = 'finished'
          return res.data
        })
    },
    getSurvey (slug, token, locale = null, anonymousGuest = null) {
      const startedAt = performance.now()
      var append = token ? `/${token}` : ''
      if (locale) {
        append += '?locale=' + locale
      }
      if (anonymousGuest) {
        append += '&g=' + anonymousGuest
      }
      if (this.pms_external_id) {
        append += '&token=' + this.pms_external_id
      }
      return axios
        .get(`${process.env.SURVEYS_API_URL}/surveys/${slug}${append}`)
        .then(res => {
          this.survey = res.data.survey
          this.fillSurveyNpsField(this.$route.query.value)
          this.survey.fields = this.survey.fields
            .map(field => {
              field.externalOrder = field.groupId
                ? field.group.order
                : field.order
              return field
            })
            .sort((a, b) => {
              return a.externalOrder - b.externalOrder
            })
          this.surveyStatus = res.data.status
          this.loadedSurvey = true

          // We will skip these analytics for now
          if (this.surveyStatus === 'finished') { this.analytics.surveyFinished = true }

          const finishedAt = performance.now()
          this.analytics.event('loadedSurvey', {
            timeTaken: finishedAt - startedAt
          })
          this.analytics.trackScrolling()
          return true
        })
    },
    performActions (time, actions, applicableActions) {
      actions
        .filter(action => {
          return action.time === time
        })
        .filter(action => {
          // Only apply action if the api tell us that it is applicable based on some rules
          return applicableActions.includes(action.id)
        })
        .sort((a, b) => {
          return a.order - b.order
        })
        .forEach(action => {
          setTimeout(() => {
            switch (action.type) {
              case 'redirect':
                this.analytics.event('redirectionAfterSubmitting', action)
                window.location.href = action.action
                break
            }
          }, action.delay * 1000)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/SurveyActionsMixin.js